import * as React from "react";
import { ChartUnit, GroupBy, GroupByToLabel } from "./utils";

interface Props {
  chartHeight?: number;
  chartWidth?: number;
  chartDataUnits: ChartUnit[];
  payload?: undefined | { dataKey: string; color: string; value: string; payload: { fill: string; stroke: string } }[];
  groupBy: GroupBy;
  filters: string[];
  onClick: (value: string, reverse: boolean) => void;
  className?: string;
}
export const CustomLegend: React.FC<Props> = ({
  chartDataUnits,
  payload,
  groupBy,
  filters,
  onClick,
  className = "",
}) => {
  if (!payload || payload.length < 1) return null;

  if (groupBy === "account") return null;

  return (
    <div className="flex items-center flex-col gap-2 my-2 pt-2 rounded border">
      <div>{GroupByToLabel(groupBy)}</div>
      <div className={`p-2 flex items-center justify-center flex-wrap gap-4 ${className}`}>
        {payload.map((p) => {
          if (p.value === "cpln-placeholder-hover") {
            return null;
          }

          const isProjected = p.value.includes("projected");
          if (isProjected) {
            return null;
          }

          let unitDataKey = p.value
            .replace("primaryTotalMapForDisplay.", "")
            .replace("secondaryTotalMapForDisplay.", "")
            .replace("valueMapForDisplay.", "")
            .replace("projectedTotalMapForDisplay.", "")
            .replace("projectedValueMapForDisplay.", "");

          const chartDataUnit = chartDataUnits.find((cdu) => cdu.dataKey === unitDataKey);

          const isFilteredOut = filters.length > 0 && !filters.includes(unitDataKey);

          return (
            <div
              key={p.dataKey}
              onClick={(e) => {
                onClick(unitDataKey, e.ctrlKey);
              }}
              className="flex items-center cursor-pointer"
            >
              <span
                className="w-4 h-2 border rounded-sm mr-1"
                style={{ backgroundColor: isFilteredOut ? "#ccc" : chartDataUnit?.color }}
              />
              <span>{chartDataUnit?.label || unitDataKey}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
